import { render, staticRenderFns } from "./CtyxPrivateProtocal.vue?vue&type=template&id=28742ece&scoped=true&"
import script from "./CtyxPrivateProtocal.vue?vue&type=script&lang=js&"
export * from "./CtyxPrivateProtocal.vue?vue&type=script&lang=js&"
import style0 from "./CtyxPrivateProtocal.vue?vue&type=style&index=0&id=28742ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28742ece",
  null
  
)

export default component.exports